var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 10.5H15.1667V8.16671H12.8333M14 23.3334C8.85501 23.3334 4.66668 19.145 4.66668 14C4.66668 8.85504 8.85501 4.66671 14 4.66671C19.145 4.66671 23.3333 8.85504 23.3333 14C23.3333 19.145 19.145 23.3334 14 23.3334ZM14 2.33337C12.4679 2.33337 10.9508 2.63514 9.53537 3.22145C8.1199 3.80775 6.83378 4.66711 5.75043 5.75046C3.56251 7.93839 2.33334 10.9058 2.33334 14C2.33334 17.0942 3.56251 20.0617 5.75043 22.2496C6.83378 23.333 8.1199 24.1923 9.53537 24.7786C10.9508 25.3649 12.4679 25.6667 14 25.6667C17.0942 25.6667 20.0617 24.4375 22.2496 22.2496C24.4375 20.0617 25.6667 17.0942 25.6667 14C25.6667 12.468 25.3649 10.9509 24.7786 9.5354C24.1923 8.11994 23.3329 6.83381 22.2496 5.75046C21.1662 4.66711 19.8801 3.80775 18.4647 3.22145C17.0492 2.63514 15.5321 2.33337 14 2.33337ZM12.8333 19.8334H15.1667V12.8334H12.8333V19.8334Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon_information.eb43c75dd47bb5ae839ec3d50023590e.svg";
export { ForwardRef as ReactComponent };